// `shortlist-extension-alerts.tpl.html:126` — the left rail's section list.
//
// It sits BELOW the alert tab inside `.shortlist-tabs-container`, and both only exist in the
// FULL view mode (`ng-if="currentViewMode === ViewMode.FullMode"`), which is the edit-alert
// screen. The slim review screen has neither.
import type { ReactElement } from 'react'
import type { CriteriaNavigationOption } from './criteriaNavigation.ts'

export interface CriteriaNavigationProps {
  options: readonly CriteriaNavigationOption[]
  /** The element ids `usedNavigationOptions` marked used — they render bolder and darker. */
  used?: ReadonlySet<string>
  onNavigate?: (option: CriteriaNavigationOption) => void
}

export function CriteriaNavigation({ options, used, onNavigate }: CriteriaNavigationProps): ReactElement {
  return (
    <div className="extension-criteria-navigation-container">
      {/* ⚠️ THE DENOMINATOR IS THE OPTION COUNT, NOT A CONSTANT. It is 7, 8 or 9 depending on
          whether the tenant has ATS filters and external sources configured. */}
      <div className="extension-criteria-used-filters-count">
        Filters used{' '}
        <span>
          {used?.size ?? 0}/{options.length}
        </span>
      </div>
      <div>
        {options.map((option) => (
          <div
            key={option.elementId}
            className={`cursor-pointer extension-criteria-filter${
              used?.has(option.elementId) === true ? ' extension-criteria-filter-used' : ''
            }`}
            role="button"
            tabIndex={0}
            onClick={() => onNavigate?.(option)}
            onKeyDown={(event) => {
              if (event.key !== 'Enter' && event.key !== ' ') return
              event.preventDefault()
              onNavigate?.(option)
            }}
          >
            {option.title}
          </div>
        ))}
      </div>
    </div>
  )
}
